import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/state";
import { ResponseModel } from "../models/common/ResponseModel";
import { AxiosError } from "axios";
import { ARIA_SuccessCode, GetKioskLocationsResponseModel } from "models";
import { getKioskLocationListAPI } from "services/locationService";

const initialState: RootState.KioskLocationState = {
  kioskLocationList: [],
  error: undefined,
  isLoading: false,
};

//Actions
//More info here https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchKioskLocationList = createAsyncThunk<
  GetKioskLocationsResponseModel,
  void,
  { rejectValue: AxiosError<Error> }
>("kioskLocation/getKioskLocationList", async (_, thunkApi) => {
  try {
    var pageIndex = 1;

    let data: GetKioskLocationsResponseModel =
      await getKioskLocationListAPI({ pageIndex });

    let tempData = data.result.items;

    while (data.result.pageCount > pageIndex) {
      pageIndex++;
      let nextData: GetKioskLocationsResponseModel =
        await getKioskLocationListAPI({ pageIndex });

      tempData.push(...nextData.result.items);
    }

    data.result.items = tempData;

    return data;
  } catch (err) {
    let error = err as AxiosError<Error>; // cast the error for access
    if (!error.response) {
      throw err;
    }
    // We got validation errors, let's return those so we can reference in our component and set form errors
    return thunkApi.rejectWithValue(error);
  }
});

//Slice
//More info here https://redux-toolkit.js.org/api/createSlice
export const kioskLocationSlice = createSlice({
  name: "kioskLocation",
  initialState,
  reducers: {
    //local reducer
    resetKioskLocationState() {
      return initialState;
    },
  },
  //services reducers
  extraReducers: (builder) => {
    builder.addCase(
      fetchKioskLocationList.fulfilled,
      (state, { payload }) => {
        if (payload.resultCode === ARIA_SuccessCode) {
          state.kioskLocationList = payload.result.items;
          state.error = undefined;
        } else {
          state.error = { ...payload };
        }

        state.error = undefined;
        state.isLoading = false;
      }
    ),
      builder.addCase(fetchKioskLocationList.pending, (state, _) => {
        state.isLoading = true;
      }),
      builder.addCase(
        fetchKioskLocationList.rejected,
        (state, action) => {
          if (action.payload != undefined) {
            let error: AxiosError<Error> = action.payload;

            const serverError: ResponseModel = {
              resultCode: error?.response?.status.toString() ?? "",
              resultDescription: error?.response?.data.message ?? "",
            };

            state.error = serverError;
            state.isLoading = false;
          }
        }
      );
  },
});

export const { resetKioskLocationState } = kioskLocationSlice.actions;

export default kioskLocationSlice.reducer;
